// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BudgetPanel ion-checkbox {
  --checkbox-background-checked: white;
  --checkmark-color: var(--smartflip-blue, black);
}
.BudgetPanel__RightSide {
  position: absolute;
  right: 3rem;
  top: 0;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/property-details/components/budget-panel/budget-panel.component.scss"],"names":[],"mappings":"AACE;EACE,oCAAA;EACA,+CAAA;AAAJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;AADJ","sourcesContent":[".BudgetPanel {\n  ion-checkbox {\n    --checkbox-background-checked: white;\n    --checkmark-color: var(--smartflip-blue, black);\n  }\n\n  &__RightSide {\n    position: absolute;\n    right: 3rem;\n    top: 0;\n    display: flex;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
